const FETCH_COHORT = 'adebify-ltv-cohort/FETCH_COHORT';
const FETCH_COHORT_SUCCEEDED = 'adebify-ltv-cohort/FETCH_COHORT_SUCCEEDED';
const REQUEST_START = 'adebify-ltv-cohort/REQUEST_START';
const REQUEST_FAILED = 'adebify-ltv-cohort/REQUEST_FAILED';

const SET_CUMULATIVE_MODE = 'adebify-ltv-cohort/SET_CUMULATIVE_MODE';
const SET_METRIC = 'adebify-ltv-cohort/SET_METRIC';
const SET_AXIS = 'adebify-ltv-cohort/SET_AXIS';
const HYDRATE_SETTINGS = 'adebify-ltv-cohort/HYDRATE_SETTINGS';
const SET_FILTERS = 'adebify-ltv-cohort/SET_FILTERS';
const DOWNLOAD_CSV = 'adebify-ltv-cohort/DOWNLOAD_CSV';

export default {
  FETCH_COHORT,
  FETCH_COHORT_SUCCEEDED,
  REQUEST_START,
  REQUEST_FAILED,
  SET_CUMULATIVE_MODE,
  SET_METRIC,
  SET_AXIS,
  HYDRATE_SETTINGS,
  SET_FILTERS,
  DOWNLOAD_CSV,
};
